import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import AdminSidebarContent from "./AdminSidebarContent";

const Sidebar = ({ mobileSidebarOpen, closeMobileSidebar }) => {
	return (
		<div className={`vertical-menu${mobileSidebarOpen ? " mobile-open" : ""}`}>
			<div data-simplebar className="h-100">
				<AdminSidebarContent closeMobileSidebar={closeMobileSidebar} />
			</div>
		</div>
	);
};

Sidebar.propTypes = {
	type: PropTypes.string,
	mobileSidebarOpen: PropTypes.bool,
	closeMobileSidebar: PropTypes.func,
};

const mapStatetoProps = (state) => {
	return {
		layout: state.Layout,
	};
};
export default connect(
	mapStatetoProps,
	{}
)(withRouter(withTranslation()(Sidebar)));
